import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { IEntityPreview } from '../../components/Entity/interfaces'
import { fetchRecordDataByIdForPreview } from '../../services/entityServices'

export const useGetEntityInstanceData = (
    orgId: string,
    entityInstanceId: string,
): UseQueryResult<IEntityPreview, Error> => {
    return useQuery<IEntityPreview>({
        queryKey: ['entityData', entityInstanceId, orgId],
        queryFn: () => {
            if (!entityInstanceId) {
                return {} as IEntityPreview
            }
            return fetchRecordDataByIdForPreview(
                orgId,
                entityInstanceId,
            ) as Promise<IEntityPreview>
        },
        refetchOnWindowFocus: false,
    })
}
